import { useState } from 'react'
import { useWindowSize } from '../../../../../core/hooks/common/useWindowSize'
import { useAclContext } from '../../../../../core/contexts/acl'
import { TABLET_SIZE } from '../../../../../core/constants/common'
import BankTransactionTable from '../bankTransactions/BankTransactionTable'
import RBankTransactionTable from '../../../../responsive/main/reports/bank-transactions/RBankTransactionTable'
import { useGetBankTransactions } from '../../../../../core/services/react-query/report/banking'
import {
	bankTransactionOptions,
	bankTransactionSortOptions,
	CacheKeys,
} from '../../../../../core/constants/filter'
import FilterLayout from '../../../../layout/filter/FilterLayout'

const ManualDeposits = () => {
	const { width } = useWindowSize()
	const [deposits, setDeposits] = useState({ data: null, loading: true })

	const { permissions } = useAclContext()
	const hasDownload = permissions?.export?.write

	const onQuerySuccess = (res) => {
		setDeposits(res)
	}

	const Component = width > TABLET_SIZE ? BankTransactionTable : RBankTransactionTable

	return (
		<FilterLayout
			query={useGetBankTransactions}
			onQuerySuccess={onQuerySuccess}
			options={bankTransactionOptions}
			cache={CacheKeys.BANK_TRANSACTIONS}
			hasDownload={hasDownload}
			sortOptions={bankTransactionSortOptions}
			extra={{ flow: 'deposit', type: 'manual' }}
		>
			{width && <Component data={deposits} manualType={'deposit'} />}
		</FilterLayout>
	)
}

export default ManualDeposits
